/* eslint-disable */
import Vue from 'vue';
import Vuex from 'vuex';
import AuthModule from './modules/auth';
import UserModule from './modules/user';
import LandingPageBuilderModule from './modules/landingPageBuilder';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    AuthModule,
    UserModule,
    LandingPageBuilderModule,
  },
});
